// (() => {
//   const MOBILE_QUERY = '(max-width: 749px)';
//   const WARNING_SELECTOR = '[data-size-validation-warning]';
//   const VALIDATION_CLASS = 'size-validation-active';
//   const ERROR_CLASS = 'size-validation-error';
//   const STICKY_CLASS = 'size-validation-sticky';
//   const STICKY_ACTIVE_CLASS = 'size-validation-sticky-active';
//   const STICKY_SENTINEL_CLASS = 'size-validation-sticky-sentinel';
//   const STICKY_TOGGLE_BUFFER = 4;
//   const STICKY_HEIGHT_VAR = '--size-validation-atc-height';

//   const mobileMedia = window.matchMedia(MOBILE_QUERY);
//   const initialVariantId = new URL(window.location.href).searchParams.get('variant');
//   const activeErrorSections = new Set();
//   const userSelectedSizeContexts = new Set();
//   const pendingSizeSelectionSections = new Set();
//   let stickyFrame = null;

//   const getSectionKey = (productInfo) => productInfo?.dataset.section || productInfo?.id || 'main-product';
//   const getStorageKey = (productInfo) => `size-validation-selected-${productInfo?.dataset.productId || getSectionKey(productInfo)}`;
//   const getCurrentVariantId = (productInfo) =>
//     productInfo?.querySelector('form[data-type="add-to-cart-form"] [name="id"]')?.value || '';
//   const hasStoredSizeSelection = (productInfo) =>
//     Boolean(initialVariantId && sessionStorage.getItem(getStorageKey(productInfo)) === initialVariantId);
//   const storeSizeSelection = (productInfo) => {
//     const variantId = getCurrentVariantId(productInfo);
//     if (variantId) sessionStorage.setItem(getStorageKey(productInfo), variantId);
//   };
//   const clearStoredSizeSelection = (productInfo) => sessionStorage.removeItem(getStorageKey(productInfo));

//   const isActiveForProduct = (productInfo) =>
//     productInfo?.dataset.sizeValidationMode === 'all' ||
//     (productInfo?.dataset.sizeValidationMode === 'mobile' && mobileMedia.matches);

//   const getVisibleStickyElementBottom = (element, requireStuck = false) => {
//     if (!element) return 0;

//     const style = window.getComputedStyle(element);
//     if (style.position !== 'fixed' && style.position !== 'sticky') return 0;

//     const rect = element.getBoundingClientRect();
//     if (rect.bottom <= 0) return 0;
//     if (requireStuck) {
//       const top = parseFloat(style.top) || 0;
//       return rect.top <= top + 1 ? rect.bottom : 0;
//     }
//     if (rect.top > 1) return 0;

//     return rect.bottom;
//   };

//   const getStickyTopOffset = () => {
//     const headerBottom = getVisibleStickyElementBottom(document.querySelector('.section-header'), true);

//     if (!headerBottom) return 0;

//     return Math.max(headerBottom, getVisibleStickyElementBottom(document.querySelector('.announcement-bar-section')));
//   };

//   const getStoredStickyHeight = (addToCart) => parseFloat(addToCart?.dataset.sizeValidationStickyHeight) || 0;

//   const storeStickyHeight = (addToCart) => {
//     if (!addToCart || addToCart.classList.contains(STICKY_CLASS)) return getStoredStickyHeight(addToCart);

//     const height = addToCart.getBoundingClientRect().height;
//     if (!height) return getStoredStickyHeight(addToCart);

//     addToCart.dataset.sizeValidationStickyHeight = `${height}`;
//     addToCart.closest('product-form')?.style.setProperty(STICKY_HEIGHT_VAR, `${height}px`);
//     return height;
//   };

//   const setStickyActive = (productInfo, isSticky) => {
//     const addToCart = productInfo?.querySelector('.addtocart-wishlist');
//     if (addToCart) {
//       getStickySentinel(addToCart);
//       storeStickyHeight(addToCart);
//     }

//     productInfo?.classList.toggle(STICKY_ACTIVE_CLASS, Boolean(isSticky));
//     addToCart?.classList.toggle(STICKY_CLASS, Boolean(isSticky));
//   };

//   const getStickyTriggerBottom = (addToCart, sentinel) => {
//     const sentinelTop = sentinel.getBoundingClientRect().top;
//     return sentinelTop + (storeStickyHeight(addToCart) || addToCart.offsetHeight);
//   };

//   const getStickySentinel = (addToCart) => {
//     const previous = addToCart.previousElementSibling;
//     if (previous?.classList.contains(STICKY_SENTINEL_CLASS)) {
//       previous.removeAttribute('style');
//       return previous;
//     }

//     const sentinel = document.createElement('span');
//     sentinel.className = STICKY_SENTINEL_CLASS;
//     sentinel.setAttribute('aria-hidden', 'true');
//     addToCart.before(sentinel);
//     return sentinel;
//   };

//   const shouldShowSticky = (productInfo) => {
//     if (!isActiveForProduct(productInfo) || !mobileMedia.matches) return false;

//     const addToCart = productInfo.querySelector('.addtocart-wishlist');
//     if (!addToCart) return false;

//     const sentinel = getStickySentinel(addToCart);
//     const rect = sentinel.getBoundingClientRect();
//     const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
//     const stickyTopOffset = getStickyTopOffset();
//     const triggerBottom = getStickyTriggerBottom(addToCart, sentinel);
//     const isSticky = addToCart.classList.contains(STICKY_CLASS);
//     const hideThreshold = stickyTopOffset + (isSticky ? STICKY_TOGGLE_BUFFER : 0);
//     const showThreshold = stickyTopOffset - (isSticky ? 0 : STICKY_TOGGLE_BUFFER);
//     const normalButtonVisible = rect.top < viewportHeight && triggerBottom > hideThreshold;

//     if (normalButtonVisible) return false;

//     return rect.top < showThreshold && triggerBottom <= showThreshold;
//   };

//   const updateStickyState = (root = document) => {
//     if (root.matches?.('product-info[data-size-validation-mode]')) {
//       setStickyActive(root, shouldShowSticky(root));
//     }

//     root.querySelectorAll('product-info[data-size-validation-mode]').forEach((productInfo) => {
//       setStickyActive(productInfo, shouldShowSticky(productInfo));
//     });
//   };

//   const requestStickyUpdate = (root = document) => {
//     if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
//     stickyFrame = window.requestAnimationFrame(() => {
//       stickyFrame = null;
//       updateStickyState(root);
//     });
//   };

//   const getRequiredPicker = (productInfo) => {
//     const pickers = Array.from(productInfo.querySelectorAll('[data-size-validation-option]'));
//     if (!pickers.length) return null;

//     return pickers.find((picker) => picker.dataset.sizeValidationOption?.includes('size')) || null;
//   };

//   const getSelectedControl = (picker) => {
//     const checkedInput = picker.querySelector('input[type="radio"]:checked');
//     if (checkedInput) return checkedInput;

//     const select = picker.querySelector('select');
//     if (select && select.value) return select;

//     return null;
//   };

//   const clearPickerSelection = (picker) => {
//     picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
//       input.checked = false;
//       input.removeAttribute('checked');
//     });

//     const select = picker.querySelector('select');
//     if (select) select.selectedIndex = -1;
//   };

//   const hideValidation = (productInfo) => {
//     activeErrorSections.delete(getSectionKey(productInfo));
//     delete productInfo.dataset.sizeValidationErrorActive;
//     productInfo.classList.remove(ERROR_CLASS);
//     productInfo.querySelectorAll(`.${ERROR_CLASS}`).forEach((element) => element.classList.remove(ERROR_CLASS));
//     productInfo.querySelector(WARNING_SELECTOR)?.setAttribute('hidden', '');
//     requestStickyUpdate(productInfo);
//   };

//   const showValidation = (productInfo, picker, scrollToPicker = true) => {
//     activeErrorSections.add(getSectionKey(productInfo));
//     productInfo.dataset.sizeValidationErrorActive = 'true';
//     productInfo.classList.add(ERROR_CLASS);
//     picker.classList.add(ERROR_CLASS);
//     productInfo.querySelector(WARNING_SELECTOR)?.removeAttribute('hidden');
//     requestStickyUpdate(productInfo);
//     if (scrollToPicker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
//   };

//   const shouldClearSizeSelection = (productInfo, picker, isActive) =>
//     isActive &&
//     picker &&
//     productInfo.dataset.sizeValidationUserSelected !== 'true' &&
//     !userSelectedSizeContexts.has(getStorageKey(productInfo)) &&
//     (!initialVariantId || !hasStoredSizeSelection(productInfo));

//   const updateProductState = (productInfo) => {
//     const isActive = isActiveForProduct(productInfo);
//     const picker = getRequiredPicker(productInfo);

//     productInfo.classList.toggle(VALIDATION_CLASS, Boolean(isActive));
//     setStickyActive(productInfo, shouldShowSticky(productInfo));

//     if (!picker) {
//       hideValidation(productInfo);
//       return;
//     }

//     if (shouldClearSizeSelection(productInfo, picker, isActive)) {
//       clearPickerSelection(picker);
//     }

//     if (!isActive) {
//       hideValidation(productInfo);
//       return;
//     }

//     if (
//       productInfo.dataset.sizeValidationErrorActive === 'true' ||
//       activeErrorSections.has(getSectionKey(productInfo))
//     ) {
//       if (getSelectedControl(picker)) {
//         hideValidation(productInfo);
//       } else {
//         showValidation(productInfo, picker, false);
//       }
//     }
//   };

//   const init = (root = document) => {
//     if (root.matches?.('product-info[data-size-validation-mode]')) updateProductState(root);
//     root.querySelectorAll('product-info[data-size-validation-mode]').forEach(updateProductState);
//   };

//   document.addEventListener(
//     'submit',
//     (event) => {
//       const form = event.target.closest('form[data-type="add-to-cart-form"]');
//       if (!form) return;

//       const productInfo = form.closest('product-info[data-size-validation-mode]');
//       if (!isActiveForProduct(productInfo)) return;

//       const picker = getRequiredPicker(productInfo);
//       if (!picker || getSelectedControl(picker)) return;

//       event.preventDefault();
//       event.stopImmediatePropagation();
//       showValidation(productInfo, picker);
//     },
//     true
//   );

//   document.addEventListener('change', (event) => {
//     const productInfo = event.target.closest('product-info[data-size-validation-mode]');
//     const picker = event.target.closest('[data-size-validation-option]');
//     if (!productInfo || !picker || !getSelectedControl(picker)) return;

//     const requiredPicker = getRequiredPicker(productInfo);
//     if (picker !== requiredPicker) {
//       delete productInfo.dataset.sizeValidationUserSelected;
//       userSelectedSizeContexts.delete(getStorageKey(productInfo));
//       pendingSizeSelectionSections.delete(getSectionKey(productInfo));
//       clearStoredSizeSelection(productInfo);
//       if (requiredPicker) clearPickerSelection(requiredPicker);
//       return;
//     }

//     productInfo.dataset.sizeValidationUserSelected = 'true';
//     userSelectedSizeContexts.add(getStorageKey(productInfo));
//     pendingSizeSelectionSections.add(getSectionKey(productInfo));
//     window.requestAnimationFrame(() => storeSizeSelection(productInfo));
//     hideValidation(productInfo);
//   });

//   document.addEventListener('DOMContentLoaded', () => init());
//   document.addEventListener('product-info:loaded', (event) => init(event.target));
//   document.addEventListener('product:render', () => window.requestAnimationFrame(() => init()));
//   window.addEventListener('scroll', () => requestStickyUpdate(), { passive: true });
//   window.addEventListener('resize', () => requestStickyUpdate());
//   mobileMedia.addEventListener?.('change', () => init());

//   if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
//     subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
//       const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
//       if (!productInfo) return;

//       window.requestAnimationFrame(() => {
//         init(productInfo);

//         const picker = getRequiredPicker(productInfo);
//         if (
//           pendingSizeSelectionSections.has(getSectionKey(productInfo)) &&
//           productInfo.dataset.sizeValidationUserSelected === 'true' &&
//           picker &&
//           getSelectedControl(picker)
//         ) {
//           storeSizeSelection(productInfo);
//           pendingSizeSelectionSections.delete(getSectionKey(productInfo));
//         }
//       });
//     });
//   }
// })();





(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const WARNING_SELECTOR = '[data-size-validation-warning]';
  const VALIDATION_CLASS = 'size-validation-active';
  const ERROR_CLASS = 'size-validation-error';
  const STICKY_CLASS = 'size-validation-sticky';
  const STICKY_ACTIVE_CLASS = 'size-validation-sticky-active';
  const STICKY_SENTINEL_CLASS = 'size-validation-sticky-sentinel';
  const STICKY_TOGGLE_BUFFER = 4;
  const STICKY_HEIGHT_VAR = '--size-validation-atc-height';
  const PRODUCT_INFO_SELECTOR = 'product-info';

  const mobileMedia = window.matchMedia(MOBILE_QUERY);
  const initialVariantId = new URL(window.location.href).searchParams.get('variant');
  const activeErrorSections = new Set();
  const userSelectedSizeContexts = new Set();
  const pendingSizeSelectionSections = new Set();
  let stickyFrame = null;

  const getSectionKey = (productInfo) => productInfo?.dataset.section || productInfo?.id || 'main-product';
  const getStorageKey = (productInfo) => `size-validation-selected-${productInfo?.dataset.productId || getSectionKey(productInfo)}`;
  const getCurrentVariantId = (productInfo) =>
    productInfo?.querySelector('form[data-type="add-to-cart-form"] [name="id"]')?.value || '';
  const hasStoredSizeSelection = (productInfo) =>
    Boolean(initialVariantId && sessionStorage.getItem(getStorageKey(productInfo)) === initialVariantId);
  const storeSizeSelection = (productInfo) => {
    const variantId = getCurrentVariantId(productInfo);
    if (variantId) sessionStorage.setItem(getStorageKey(productInfo), variantId);
  };
  const clearStoredSizeSelection = (productInfo) => sessionStorage.removeItem(getStorageKey(productInfo));

  const isActiveForProduct = (productInfo) =>
    productInfo?.dataset.sizeValidationMode === 'all' ||
    (productInfo?.dataset.sizeValidationMode === 'mobile' && mobileMedia.matches);

  const hasStickyAddToCart = (productInfo) => Boolean(productInfo?.querySelector('.addtocart-wishlist'));

  const getVisibleStickyElementBottom = (element, requireStuck = false) => {
    if (!element) return 0;

    const style = window.getComputedStyle(element);
    if (style.position !== 'fixed' && style.position !== 'sticky') return 0;

    const rect = element.getBoundingClientRect();
    if (rect.bottom <= 0) return 0;
    if (requireStuck) {
      const top = parseFloat(style.top) || 0;
      return rect.top <= top + 1 ? rect.bottom : 0;
    }
    if (rect.top > 1) return 0;

    return rect.bottom;
  };

  const getStickyTopOffset = () => {
    const headerBottom = getVisibleStickyElementBottom(document.querySelector('.section-header'), true);

    if (!headerBottom) return 0;

    return Math.max(headerBottom, getVisibleStickyElementBottom(document.querySelector('.announcement-bar-section')));
  };

  const getStoredStickyHeight = (addToCart) => parseFloat(addToCart?.dataset.sizeValidationStickyHeight) || 0;

  const storeStickyHeight = (addToCart) => {
    if (!addToCart || addToCart.classList.contains(STICKY_CLASS)) return getStoredStickyHeight(addToCart);

    const height = addToCart.getBoundingClientRect().height;
    if (!height) return getStoredStickyHeight(addToCart);

    addToCart.dataset.sizeValidationStickyHeight = `${height}`;
    addToCart.closest('product-form')?.style.setProperty(STICKY_HEIGHT_VAR, `${height}px`);
    return height;
  };

  const setStickyActive = (productInfo, isSticky) => {
    const addToCart = productInfo?.querySelector('.addtocart-wishlist');
    if (addToCart) {
      getStickySentinel(addToCart);
      storeStickyHeight(addToCart);
    }

    productInfo?.classList.toggle(STICKY_ACTIVE_CLASS, Boolean(isSticky));
    addToCart?.classList.toggle(STICKY_CLASS, Boolean(isSticky));
  };

  const getStickyTriggerBottom = (addToCart, sentinel) => {
    const sentinelTop = sentinel.getBoundingClientRect().top;
    return sentinelTop + (storeStickyHeight(addToCart) || addToCart.offsetHeight);
  };

  const getStickySentinel = (addToCart) => {
    const previous = addToCart.previousElementSibling;
    if (previous?.classList.contains(STICKY_SENTINEL_CLASS)) {
      previous.removeAttribute('style');
      return previous;
    }

    const sentinel = document.createElement('span');
    sentinel.className = STICKY_SENTINEL_CLASS;
    sentinel.setAttribute('aria-hidden', 'true');
    addToCart.before(sentinel);
    return sentinel;
  };

  const shouldShowSticky = (productInfo) => {
    if (!hasStickyAddToCart(productInfo) || !mobileMedia.matches) return false;

    const addToCart = productInfo.querySelector('.addtocart-wishlist');
    if (!addToCart) return false;

    const sentinel = getStickySentinel(addToCart);
    const rect = sentinel.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const stickyTopOffset = getStickyTopOffset();
    const triggerBottom = getStickyTriggerBottom(addToCart, sentinel);
    const isSticky = addToCart.classList.contains(STICKY_CLASS);
    const hideThreshold = stickyTopOffset + (isSticky ? STICKY_TOGGLE_BUFFER : 0);
    const showThreshold = stickyTopOffset - (isSticky ? 0 : STICKY_TOGGLE_BUFFER);
    const normalButtonVisible = rect.top < viewportHeight && triggerBottom > hideThreshold;

    if (normalButtonVisible) return false;

    return rect.top < showThreshold && triggerBottom <= showThreshold;
  };

  const updateStickyState = (root = document) => {
    if (root.matches?.(PRODUCT_INFO_SELECTOR)) {
      setStickyActive(root, shouldShowSticky(root));
    }

    root.querySelectorAll(PRODUCT_INFO_SELECTOR).forEach((productInfo) => {
      setStickyActive(productInfo, shouldShowSticky(productInfo));
    });
  };

  const requestStickyUpdate = (root = document) => {
    if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
    stickyFrame = window.requestAnimationFrame(() => {
      stickyFrame = null;
      updateStickyState(root);
    });
  };

  const getRequiredPicker = (productInfo) => {
    const pickers = Array.from(productInfo.querySelectorAll('[data-size-validation-option]'));
    if (!pickers.length) return null;

    return pickers.find((picker) => picker.dataset.sizeValidationOption?.includes('size')) || null;
  };

  const getSelectedControl = (picker) => {
    const checkedInput = picker.querySelector('input[type="radio"]:checked');
    if (checkedInput) return checkedInput;

    const select = picker.querySelector('select');
    if (select && select.value) return select;

    return null;
  };

  const clearPickerSelection = (picker) => {
    picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    const select = picker.querySelector('select');
    if (select) select.selectedIndex = -1;
  };

  const hideValidation = (productInfo) => {
    activeErrorSections.delete(getSectionKey(productInfo));
    delete productInfo.dataset.sizeValidationErrorActive;
    productInfo.classList.remove(ERROR_CLASS);
    productInfo.querySelectorAll(`.${ERROR_CLASS}`).forEach((element) => element.classList.remove(ERROR_CLASS));
    productInfo.querySelector(WARNING_SELECTOR)?.setAttribute('hidden', '');
    requestStickyUpdate(productInfo);
  };

  const showValidation = (productInfo, picker, scrollToPicker = true) => {
    activeErrorSections.add(getSectionKey(productInfo));
    productInfo.dataset.sizeValidationErrorActive = 'true';
    productInfo.classList.add(ERROR_CLASS);
    picker.classList.add(ERROR_CLASS);
    productInfo.querySelector(WARNING_SELECTOR)?.removeAttribute('hidden');
    requestStickyUpdate(productInfo);
    if (scrollToPicker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const shouldClearSizeSelection = (productInfo, picker, isActive) =>
    isActive &&
    picker &&
    productInfo.dataset.sizeValidationUserSelected !== 'true' &&
    !userSelectedSizeContexts.has(getStorageKey(productInfo)) &&
    (!initialVariantId || !hasStoredSizeSelection(productInfo));

  const updateProductState = (productInfo) => {
    const isActive = isActiveForProduct(productInfo);
    const picker = getRequiredPicker(productInfo);

    productInfo.classList.toggle(VALIDATION_CLASS, Boolean(isActive || hasStickyAddToCart(productInfo)));
    setStickyActive(productInfo, shouldShowSticky(productInfo));

    if (!picker) {
      hideValidation(productInfo);
      return;
    }

    if (shouldClearSizeSelection(productInfo, picker, isActive)) {
      clearPickerSelection(picker);
    }

    if (!isActive) {
      hideValidation(productInfo);
      return;
    }

    if (
      productInfo.dataset.sizeValidationErrorActive === 'true' ||
      activeErrorSections.has(getSectionKey(productInfo))
    ) {
      if (getSelectedControl(picker)) {
        hideValidation(productInfo);
      } else {
        showValidation(productInfo, picker, false);
      }
    }
  };

  const init = (root = document) => {
    if (root.matches?.(PRODUCT_INFO_SELECTOR)) updateProductState(root);
    root.querySelectorAll(PRODUCT_INFO_SELECTOR).forEach(updateProductState);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const productInfo = form.closest('product-info[data-size-validation-mode]');
      if (!isActiveForProduct(productInfo)) return;

      const picker = getRequiredPicker(productInfo);
      if (!picker || getSelectedControl(picker)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showValidation(productInfo, picker);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const productInfo = event.target.closest('product-info[data-size-validation-mode]');
    const picker = event.target.closest('[data-size-validation-option]');
    if (!productInfo || !picker || !getSelectedControl(picker)) return;

    const requiredPicker = getRequiredPicker(productInfo);
    if (picker !== requiredPicker) {
      delete productInfo.dataset.sizeValidationUserSelected;
      userSelectedSizeContexts.delete(getStorageKey(productInfo));
      pendingSizeSelectionSections.delete(getSectionKey(productInfo));
      clearStoredSizeSelection(productInfo);
      if (requiredPicker) clearPickerSelection(requiredPicker);
      return;
    }

    productInfo.dataset.sizeValidationUserSelected = 'true';
    userSelectedSizeContexts.add(getStorageKey(productInfo));
    pendingSizeSelectionSections.add(getSectionKey(productInfo));
    window.requestAnimationFrame(() => storeSizeSelection(productInfo));
    hideValidation(productInfo);
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('product-info:loaded', (event) => init(event.target));
  document.addEventListener('product:render', () => window.requestAnimationFrame(() => init()));
  window.addEventListener('scroll', () => requestStickyUpdate(), { passive: true });
  window.addEventListener('resize', () => requestStickyUpdate());
  mobileMedia.addEventListener?.('change', () => init());

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!productInfo) return;

      window.requestAnimationFrame(() => {
        init(productInfo);

        const picker = getRequiredPicker(productInfo);
        if (
          pendingSizeSelectionSections.has(getSectionKey(productInfo)) &&
          productInfo.dataset.sizeValidationUserSelected === 'true' &&
          picker &&
          getSelectedControl(picker)
        ) {
          storeSizeSelection(productInfo);
          pendingSizeSelectionSections.delete(getSectionKey(productInfo));
        }
      });
    });
  }
})();